import { BackendError } from "types/error";

const setPath = (object: any, path: string, value: any) =>
  path
    ?.split(".")
    ?.reduce(
      (o, p, i) => (o[p] = path.split(".").length === ++i ? value : o[p] || {}),
      object,
    );

export const backendErrors = (data?: BackendError[]) =>
  data?.reduce((errors: any, item: BackendError) => {
    let errorsArray = errors[item.path];
    if (errorsArray) {
      errorsArray?.push(item.message);
    } else {
      setPath(errors, item.path, [item.message]);
    }
    return errors;
  }, {});

export const parseCampaignTranslationsArrayError = (
  translationErrors: { [translationCode: string]: string[] | string },
  languagesArray: { locale?: string }[],
): Object => {
  const errors: Object = {};
  translationErrors &&
    Object.keys(translationErrors).forEach((translationCode: string) => {
      const translationIndex = languagesArray.findIndex(
        (element) => element.locale === translationCode,
      );
      (errors as any)[`${translationIndex}`] =
        translationErrors[translationCode];
    });
  return errors;
};

export const parseTranslationsArrayError = (
  translationErrors: { [translationCode: string]: string[] | string },
  languagesArray: { code?: string }[],
): Object => {
  const errors: Object = {};
  translationErrors &&
    Object.keys(translationErrors).forEach((translationCode: string) => {
      const translationIndex = languagesArray.findIndex(
        (element) => element.code === translationCode,
      );
      (errors as any)[`${translationIndex}`] =
        translationErrors[translationCode];
    });
  return errors;
};
